import React, {Component} from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

import './SwitchUser.css';

let strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SwitchUser extends Component {
    state = {
        options: [],
    }

    componentWillReceiveProps(props) {
        console.log('props', props);
        let options = [];
        if (props.clients) {
            props.clients.forEach((client) => {
                if (client.client_name !== '') {
                    let newOption = {};
                    newOption.id = client.id;
                    newOption.label = `${client.client_name} - ${client.id}`;
                    options.push(newOption);
                }
            });
            this.setState({
                options,
            });
        }
    }

    render() {
        return (
            <div className="showtix-navigation__client pb-4">
                <div className="showtix-badge showtix-background__grey-3">
                    {strings.title}
                </div>
                <ul className="showtix-navigation__list">
                    { !this.props.isGodMode &&
                        <li className="p-2">
                            <div className="showtix-form__group pb-0">
                                <div className="showtix-form__select">
                                    <Typeahead
                                        onChange={(selected) => {
                                            this.props.switchUser(selected[0].id)
                                        }}
                                        options={this.state.options}
                                    />
                                </div>
                            </div>   
                        </li>
                    }
                    { this.props.isGodMode &&
                        <li className='showtix-navigation__item'>
                            <button
                                className="showtix-navigation__link"
                                onClick={this.props.logoutSwitchUser}
                            >
                                {strings.logout}
                            </button>
                        </li>
                    }
                </ul>
            </div>
        );
    }
}

SwitchUser.propTypes = {
    client: PropTypes.array,
    switchUser: PropTypes.func
}

export default SwitchUser;



// WEBPACK FOOTER //
// ./src/components/Navigation/SwitchUser/SwitchUser.js